import { useQuery } from 'react-query';

import {
  applicantReferencesKey,
  applicantReferencesRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type UseGetApplicantReferencesProps = {
  applicantId?: number;
  getAll?: boolean;
};

export const useGetApplicantReferences = ({
  applicantId,
  getAll = false,
}: UseGetApplicantReferencesProps) => {
  const { data: applicantReferencesData } = useQuery({
    queryKey: [applicantReferencesKey, applicantId],
    queryFn: () => {
      const params = new URLSearchParams();

      if (getAll) {
        params.append('show_all', 'true');
      }

      return axiosInstance
        .get(`${applicantReferencesRoute}${applicantId}`, { params })
        .then((res) => res.data);
    },
    enabled: Boolean(applicantId),
    refetchOnWindowFocus: false,
  });
  return { applicantReferencesData };
};
